export default __webpack_public_path__ + "static/media/content-deco-2.546281e6.webp";